<template>
<v-card flat :class='{"fullscreen": fullscreen}' >
  <appointment-picker
    group-by-name multiple with-fullscreen dark dense
    v-model='appointments'
    :with-quick-pick='false'
    :fullscreen.sync='fullscreen'
    :compact='false' />
</v-card>
</template>
<script>
import ConfirmInvoice from '@/components/invoice/manage/create/confirm'
import AppointmentPicker from '@/components/pickers/AppointmentPicker/index.vue'
import AppointmentsMixin from '@/mixins/appointments'

export default {
  name: 'AppointmentsPage',
  mixins: [AppointmentsMixin],
  components: { ConfirmInvoice, AppointmentPicker },
  data () {
    return {
      appointments: [],
      fullscreen: false
    }
  }
}
</script>
<style scoped>
.fullscreen {
  position:absolute;
  top:0px;
  left:0px;
  right:0px;
  bottom:0px;
  z-index:13;
  margin-top:-55px;
}
</style>



// WEBPACK FOOTER //
// Appointments.vue?4ecf3c86